<template>
    <v-dialog v-model="$store.state.dispatch.edtAdvice" max-width="1000px">
        <v-card>
            <v-toolbar dark color="secondary" class="white--text" dense>
                <v-spacer></v-spacer>
                <v-toolbar-title> New Terminal Advice </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn
                    dark
                    icon
                    left
                    @click="$store.state.dispatch.edtAdvice = false"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-container grid-list-xs fluid>
                <v-form ref="form" lazy-validation>
                    <v-row>
                        <v-col cols="6">
                            <v-combobox
                                label="Select Terminal"
                                dense
                                :items="terminals"
                                :item-text="'Name'"
                                :item-value="'id'"
                                auto-select-first
                                v-model="terminal"
                                :rules="[v => !!v || 'Required']"
                                required
                            ></v-combobox>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12">
                            <v-textarea
                                rows="6"
                                v-model="advice"
                                label="Advice Comment"
                                :rules="[v => !!v || 'Required']"
                                required
                            >
                            </v-textarea>
                        </v-col>
                    </v-row>
                    <v-row justify="end">
                        <v-btn color="primary" @click="validate" class="ma-2"
                            >Save</v-btn
                        >
                    </v-row>
                </v-form>
            </v-container>
        </v-card>
    </v-dialog>
</template>
<script>
import axios from 'axios';
export default {
    name: 'Drivers',
    props: ['edt'],
    data: function() {
        return {
            dialog: false,
            dataLoading: true,
            terminals: [],
            terminal: [],
            search: '',
            advice: ''
        };
    },

    computed: {
        formTitle() {
            return this.edited.id === 0 ? 'New Item' : 'Edit Item';
        }
    },

    watch: {
        dialog(val) {
            val || this.cancel();
        }
    },

    mounted() {
        this.advice = this.edt.Advice;
        this.loadTerminals();
    },

    methods: {
        loadTerminals: function() {
            var str = this.$store;
            str.state.isLoading = true;
            axios
                .get('terminal/active')
                .then(response => {
                    this.terminals = response.data.data;
                    console.log(this.terminals);
                    str.state.isLoading = false;

                    var index = this.terminals.findIndex(elm => {
                        return elm.id == this.edt.TerminalID;
                    });

                    this.terminal = this.terminals[index];
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    str.state.isLoading = false;
                });
        },
        validate() {
            if (this.$refs.form.validate() == false) {
                this.$refs.form.validate();
            } else {
                this.edtAdvice();
            }
        },
        edtAdvice: function() {
            var str = this.$store;
            str.state.isLoading = true;
            var params = {
                Advice: this.advice,
                TerminalID: this.terminal.id
            };
            console.log(params);
            axios
                .put(
                    'terminal-advice/update/' + this.edt.TerminalAdviceID,
                    params
                )
                .then(response => {
                    console.log(response.data);
                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Terminal Advice Save successful'
                    });
                    this.$store.state.dispatch.adviceWatch = true;
                    this.$store.state.dispatch.edtAdvice = false;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    str.state.isLoading = false;
                });
        }
    }
};
</script>
